<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :disabled="disabled"
      @reload="getData"
      @openSampleDialog="openSampleDialog"
      @chooseSample="() => (chooseSampleDialogVisible = true)"
      @add="openSampleDialog({ type: 'add', params })"
    >
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <SampleDialog
      :type="sampleDialogOptions.type"
      :visible.sync="sampleDialogOptions.visible"
      :title="sampleDialogOptions.title"
      :params="sampleDialogOptions.params"
      @reload="reload"
      @close="getData"
    />

    <choose-sample-dialog
      :visible.sync="chooseSampleDialogVisible"
      type="checkbox"
      @confirm="onSampleConfirm"
    />
  </div>
</template>
<script>
import PageMain from './main'
import EditLoading from '@/mixins/edit-loading'
import SampleDialog from '../sample-dialog'
import BaseTable from '@/mixins/base-table'
export default {
  components: {
    PageMain,
    SampleDialog,
  },
  mixins: [BaseTable, EditLoading],
  props: {
    proofingCode: String,
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      usePage: true,
      sampleDialogOptions: {
        visible: false,
        title: '',
        params: {},
      },
      chooseSampleDialogVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$api
        .proofingSampleInfoListApi({
          ...this.page,
          proofingCode: this.proofingCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    reload(sampleCode) {
      this.getData()
      const { type } = this.sampleDialogOptions
      if (type == 'add') {
        this.sampleDialogOptions.visible = false
        this.openSampleDialog({ type: 'edit', params: { sampleCode } })
      }
    },
    openSampleDialog({ type, params = {} }) {
      const types = {
        edit: this.$l('form_label_sample_edit') || '编辑样品信息',
        detail: this.$l('form_label_sample_detail') || '样品信息详情',
        add: this.$l('form_label_sample_add') || '添加样品信息',
      }
      this.sampleDialogOptions = {
        visible: true,
        type,
        title: types[type],
        params: { ...params, proofingCode: this.proofingCode },
      }
    },
    onSampleConfirm(data) {
      if (!data) return

      // proofingSampleInfoBatchSaveApi

      const listSampleCode = data.map((i) => i.sampleCode)
      this.loadingOpen()
      this.$api
        .proofingSampleInfoBatchSaveApi({
          listSampleCode,
          proofingCode: this.proofingCode,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })
            this.getData()
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
  },
}
</script>
